import { Fragment, useEffect, useState } from 'react'
import CustomToolTip from '../CustomToolTip'
import { EyeSvg } from '../svgs/Svgs'
import './SecurityConfigDetails.scss'
import { isEmpty } from 'lodash'
import { KeyDetailType } from './types'


const SecurityConfigDetails = ({ data }: { data: KeyDetailType[] }) => {
    const [informations, setInformations] = useState<KeyDetailType[]>(data)
    const showHideDetails = (index: number) => {
        setInformations(prev => {
            const updated = [...prev]
            updated[index] = {
                ...updated[index],
                type: updated[index].type === 'password' ? 'text' : 'password'
            }
            return updated
        })
    }

    useEffect(() => {
        setInformations(data)
    }, [data])

    return (
        <div className="security__configuration__details__table__container">
            <div className="__header__container">
                <div className="__table__row__container">
                    <div className="__table__cell cell__1">
                        <span className='__cell__detail'> Name </span>
                    </div>
                    <div className="__table__cell flexible__cell cell__2">
                        <span className='__cell__detail'> Keys </span>
                    </div>
                    <div className="__table__cell cell__4 small__cell">
                        <span className='__cell__detail'> Modified </span>
                    </div>
                </div>
            </div>

            <div className='devider' style={{ left: 250 }} />
            <div className='devider' style={{ right: 170 }} />
            <div className="__body__container">
                {informations.map((item, index) => {
                    return (
                        <div className="__table__row__container" key={index}>
                            <div className="__table__cell">
                                <span className='__cell__detail'> {item.name} </span>
                            </div>
                            <div className="__table__cell flexible__cell">
                                {!isEmpty(item.key) &&
                                    <Fragment>
                                        <CustomToolTip className='w-100' placement='top-start' title={item.type === 'text' ? item.key : ''}>
                                            <div className='__key__container'>
                                                <input className='input__container' disabled type={item.type} value={item.key} />
                                                <button className='hide__show__button'
                                                    onClick={() => showHideDetails(index)}
                                                >
                                                    <EyeSvg type={item.type} />
                                                </button>
                                            </div>
                                        </CustomToolTip>
                                        <div className={`__status__indicator ${item.active ? 'active' : ''}`}>
                                            <CustomToolTip className='h-100 w-100 z-99' title={item.active ? 'Active' : 'Inactive'}>
                                                <div />
                                            </CustomToolTip>
                                        </div>
                                    </Fragment>
                                }
                            </div>
                            <div className="__table__cell small__cell">
                                <span className='__cell__detail'> {item.modified} </span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default SecurityConfigDetails